import React from 'react';
import {BaseIconProps} from '../../types';

export const BaseDrawer: React.FC<BaseIconProps> = ({size, color}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.586 5.531A.75.75 0 0017 5.25H7a.75.75 0 00-.586.281l-4 5A.75.75 0 002.25 11v7c0 .414.336.75.75.75h18a.75.75 0 00.75-.75v-7a.75.75 0 00-.164-.469l-4-5z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 11h6s0 3 3 3 3-3 3-3h6"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
